import { render, staticRenderFns } from "./Wrapper.vue?vue&type=template&id=5c70f937"
import script from "./Wrapper.vue?vue&type=script&lang=js"
export * from "./Wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c70f937')) {
      api.createRecord('5c70f937', component.options)
    } else {
      api.reload('5c70f937', component.options)
    }
    module.hot.accept("./Wrapper.vue?vue&type=template&id=5c70f937", function () {
      api.rerender('5c70f937', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/reinbursement/Wrapper.vue"
export default component.exports